<template>
    <div class="login-page" >
        <div class="w-100 h-100 d-flex justify-content-center align-items-center flex-column">
            <div class="login_logo">
                <img :src="current_url+'/assets/images/study-logo.png'" alt="login">
            </div>
            <router-view/>
        </div>
        
    </div>
</template>

<script>

export default {
    name: "auth",

    data() {
            return {
                current_url:''
            }
        },

    mounted() {
            this.current_url = window.location.origin;
            this.current_url.slice(0, -1);
        }
}
</script>
